import { heatmapStore } from "@/routes/apt/[apt_code]/statistics/_components/heatmap/heatmap-store"
import { useSearchParams } from "react-router-dom"
import { langStore } from "@/stores/lang-store"
import { formatMessage } from "@/utils/format-message"
import { useMemo } from "react"
import useIsMobile from "@/hooks/use-is-mobile"
import { RESOURCES } from "@/constants/resource-const"
import HeatmapMobile from "./heatmap-mobile"
import HeatmapDesktop from "./heatmap-desktop"
import { statsBundle } from "../../stats-const"
import Wrapper from "@/components/wrapper"

const HeatmapView = () => {
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource")

  const { heatmaps: rawHeatmaps, visualMax } = heatmapStore()
  const heatmaps = useMemo(() => {
    return [...rawHeatmaps]
      .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
      .map(([dong, heatmap]) => [parseInt(dong).toString(), heatmap])
  }, [rawHeatmaps])

  const { lang } = langStore()
  const { label } = RESOURCES.find((r) => r.id === resource)

  const isMobile = useIsMobile()

  return (
    <Wrapper.shadow className="mt-6 min-h-full">
      <h1 className="text-2xl font-bold px-2 pb-4">
        {formatMessage(statsBundle.byDong[lang], { resource: label[lang] })}
      </h1>

      {heatmaps.length > 0 && isMobile ? (
        <HeatmapMobile heatmaps={heatmaps} label={label} visualMax={visualMax} />
      ) : (
        <HeatmapDesktop heatmaps={heatmaps} label={label} visualMax={visualMax} />
      )}
    </Wrapper.shadow>
  )
}

export default HeatmapView
